import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useStoreView } from 'hooks/useStoreView'

const win: any = window

export const useListrakPageBrowse = () => {
  const { pathname } = useLocation()
  const { isSofiaAndGrace } = useStoreView()

  useEffect(() => {
    if (isSofiaAndGrace) {
      const ltk: any = win._ltk

      // eslint-disable-next-line
      console.group('Listrak >> Page Browse')
      ltk?.Activity?.AddPageBrowse?.()
      ltk?.Activity?.Submit?.()
      // eslint-disable-next-line
      console.info('_ltk.Activity.AddPageBrowse()')
      // eslint-disable-next-line
      console.info('_ltk.Activity.Submit()')
      // eslint-disable-next-line
      console.groupEnd()
    }
  }, [pathname, isSofiaAndGrace])

  return null
}
